import { Door } from "./door"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Waves } from "./waves"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference

export class Doors {
	self: Phaser.Physics.Arcade.Group;
	closestDoor: Door | null;
	lastShotTime = 0;

	openSound: Phaser.Sound.BaseSound;

	constructor() // world: Phaser.Physics.Arcade.World,
	// scene: Phaser.Scene
	{
		// super(world, scene, {
		// 	classType: Zombie,
		// 	runChildUpdate: true,
		// });
	}

	preload(scene: Phaser.Scene): void {
		// load bullet sprites here
		// scene.load.image("rock", "assets/rock.png");

		// SOUND!
		scene.load.audio("open", [
			"release_assets/sound/door.wav"
		]);
	}

	create(scene: Phaser.Scene, map: Maps): void {
		// looks like we need a new "bullet(singular)" class for each different type of bullet!
		this.self = scene.physics.add.group({
			classType: Door,
			runChildUpdate: true
		});
		const spawnPoints: TiledObject[] = map.self.filterObjects(
			"Events",
			(obj: Phaser.GameObjects.GameObject): boolean => {
				return obj.name === "SpawnRock";
			}
		);
		for (const spawnPoint of spawnPoints) {
			const door: Door = this.self.get(-100, -100) as Door;
			door.create(spawnPoint.x, spawnPoint.y, true, 100, spawnPoint.type);
		}
		const spawnPoint: TiledObject =
			spawnPoints[Phaser.Math.RND.between(0, spawnPoints.length - 1)];

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.2
		};

		this.openSound = scene.sound.add("open", config);
	}

	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		player: Phaser.Physics.Arcade.Sprite,
		waves: Waves
	): void {
		this.closestDoor = null;
		for (const child of this.self.getChildren() as Door[]) {
			if (Phaser.Math.Distance.Between(child.x, child.y, player.x, player.y) <= 50) {
				if (child.spent >= child.cost) {
					// Play a door opening sound as proof of concept...
					this.openSound.play();

					waves.updateFlag(child.flagID,true);
					child.text.destroy();
					child.destroy();
				} else {
					this.closestDoor = child;
					child.showCost();
				}
			} else {
				child.hideCost();
			}
		}
	}
	afford(money: number): boolean {
		if (this.closestDoor) {
			if (money >= this.closestDoor.cost) {
				return true;
			}
		}
		return false;
	}

	buy(): number {
		if (this.closestDoor) {
			this.closestDoor.spent = this.closestDoor.cost;
			return this.closestDoor.cost;
		}
		return 0;
	}
}
